export function Footer() {
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 py-4 text-center text-xs text-slate-400 dark:text-slate-500 space-y-1">
      <p className="font-semibold text-red-500 dark:text-red-400">
        Research use only. Not a medical device. Not HIPAA compliant. Not for
        clinical use.
      </p>
      <p>
        Use constitutes acceptance of all terms. You bear all risk and release
        the operators from all liability.
      </p>
    </footer>
  );
}
